module.exports = __webpack_public_path__ + "assets/img/favicon.png";